import Vue from "vue";
import VueRouter from "vue-router";
import { state } from "@/store/";
Vue.use(VueRouter);
import store from "@/store";
// 解决编程式路由往同一地址跳转时会报错的情况
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;

// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};

//replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};

const routes = [
  {
    path: "/",
    name: "Home",
    component: (resolve) => require(['@/views/home/Home.vue'], resolve)
  },
  // 产品中心
  {
    path: "/product/:identification?",
    name: "product",
    component: (resolve) => require(['@/views/common/Category_product.vue'], resolve)
  },
  {
    path: "/product/more/:identification",
    name: "More",
    component: (resolve) => require(['@/views/product/more.vue'], resolve)
  },
  {
    path: "/product/detail/:identification",
    name: "Detail",
    component: (resolve) => require(['@/views/product/detail.vue'], resolve)
  },
  // 简介单页
  {
    path: "/about/:identification",
    name: "introPage",
    component: (resolve) => require(['@/views/common/Single_intro.vue'], resolve)
  },
  // 新闻栏目
  {
    path: "/news/:identification",
    name: "categoryNews",
    component: (resolve) => require(['@/views/common/Category_news.vue'], resolve)
  },
  // 新闻详情
  {
    path: "/news/:identification/:content_id",
    name: "categoryNewsDetail",
    component: (resolve) => require(['@/views/common/Detail_newsDetail.vue'], resolve)
  },
  // 服务中心
  {
    path: "/service/:identification",
    name: "productDirectory",
    component: (resolve) => require(['@/views/common/Category_productDirectory.vue'], resolve)
  },
  //纸质版申请
  {
    path: "/service/paperreq/:identification/:content_id",
    name: "paperreq",
    component: (resolve) => require(['@/views/product/paperreq.vue'], resolve)
  },
  // 购买流程
  {
    path: "/service/steps/:identification",
    name: "steps",
    component: (resolve) => require(['@/views/common/steps.vue'], resolve)
  },
  // 网站地图
  {
    path: "/service/map/:identification",
    name: "map",
    component: (resolve) => require(['@/views/common/map.vue'], resolve)
  },
  // 服务条款
  {
    path: "/service/term/:identification",
    name: "term",
    component: (resolve) => require(['@/views/common/Single_term.vue'], resolve)
  },
  // 联系我们单页
  {
    path: "/contact/:identification",
    name: "contact",
    component: (resolve) => require(['@/views/common/Single_contactUs.vue'], resolve)
  },
  //搜索结果
  {
    path: "/searchResult",
    name: "searchResult",
    component: (resolve) => require(['@/views/product/searchResult.vue'], resolve)
  },
  // 产品对比
  {
    path: "/compare",
    name: "Compare",
    component: (resolve) => require(['@/views/product/compare.vue'], resolve)
  },
  // 加入产品咨询
  {
    path: "/inquiry",
    name: "inquiry",
    component: (resolve) => require(['@/views/pay/inquiry.vue'], resolve)
  },
  // 加入购物车
  {
    path: "/shoppingCart",
    name: "ShoppingCart",
    component: (resolve) => require(['@/views/pay/shoppingCart.vue'], resolve)
  },
  // 结算页 地址
  {
    path: "/addressInformation",
    name: "addressInformation",
    component: (resolve) => require(['@/views/pay/addressInformation.vue'], resolve)
  },
  // 结算页 物流
  {
    path: "/shippingMethod",
    name: "shippingMethod",
    component: (resolve) => require(['@/views/pay/shippingMethod.vue'], resolve)
  },
  // 结算页 付款页
  {
    path: "/purchase",
    name: "Purchase",
    component: (resolve) => require(['@/views/pay/purchase.vue'], resolve)
  },
  // 结算成功
  {
    path: "/purchaseSuccess",
    name: "PurchaseSuccess",
    component: (resolve) => require(['@/views/pay/purchaseSuccess.vue'], resolve)
  },
  // 结算失败
  {
    path: "/purchaseError",
    name: "purchaseError",
    component: (resolve) => require(['@/views/pay/purchaseError.vue'], resolve)
  },
  // 登录
  {
    path: "/login",
    name: "Login",
    component: (resolve) => require(['@/views/user/login.vue'], resolve)
  },
  // 注册
  {
    path: "/register",
    name: "Resgiter",
    component: (resolve) => require(['@/views/user/register.vue'], resolve)
  },
  // 找回密码
  {
    path: "/getpsw",
    name: "Getpsw",
    component: (resolve) => require(['@/views/user/getpsw.vue'], resolve)
  },
  // 会员中心
  {
    path: "/userCenter",
    name: "UserCenter",
    component: (resolve) => require(['@/views/user/userCenter.vue'], resolve)
  },
  // 订单详情
  {
    path: "/userCenter/orderdetail",
    name: "orderdetail",
    component: (resolve) => require(['@/views/user/components/orderdetail.vue'], resolve)
  },
  // 咨询详情
  {
    path: "/userCenter/inquirydetail",
    name: "inquirydetail",
    component: (resolve) => require(['@/views/user/components/inquirydetail.vue'], resolve)
  },
  // 404
  {
    path: "/404",
    name: "404",
    component: (resolve) => require(['@/views/common/404.vue'], resolve)
  },
  {
    path: "*",
    redirect: "/404"
  }
];
const router = new VueRouter({
  mode: "history",
  base:
    process.env.NODE_ENV !== "production"
      ? process.env.BASE_URL
      : process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // return { x: 0, y: 0 };
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

export default router;

router.onError(err => {
  if (err.name === "ChunkLoadError") {
    router.app.$notify.error("网络资源加载错误");
  }
});
router.beforeEach((to, from, next) => {
  // console.log(state);
  // if (to.path === "/login" && state.isLogin) {
  //   return next("/");
  // }
  // if (to.meta.loginRequired && !state.isLogin) {
  //   return next("/login");
  // }
  const currentRoute = to.path;
  // 更新Vuex中的路由历史
  store.commit('updateRouteHistory', currentRoute);
  // next();

  next();
});
